import { CustomAppLayout } from '../../../layout';

// Copyright Amazon.com, Inc. or its affiliates. All Rights Reserved.
// SPDX-License-Identifier: MIT-0
import BreadcrumbGroup from '@cloudscape-design/components/breadcrumb-group';
import React, { useCallback, useEffect, useMemo, useState } from 'react';
const _preserve = React.version;
//import { useStore } from '../store';
import { useGlobalState } from '../../../../context/GlobalStateContext';

import { Alert, Badge, Box, Button, Cards, FormField, KeyValuePairs, Link, Modal, SpaceBetween, Table, Tabs, TextFilter } from '@cloudscape-design/components';
import Header from "@cloudscape-design/components/header";
import { mdiCheckCircle, mdiMapMarkerRightOutline, mdiRadar, mdiSpiderOutline } from '@mdi/js';
import { Icon } from '@mdi/react';
import { GoogleMap, Marker, useJsApiLoader } from '@react-google-maps/api';
import { format, fromUnixTime } from 'date-fns';
import Favorites from '../../../../../components/extras/Favorites';
import SidePanelMant from '../../../../../components/extras/SidePanelMant';
import TableBookings from '../../../../../components/tables/tableBookings';
import TableFlights from '../../../../../components/tables/tableFlights';
import TableManttos from '../../../../../components/tables/tableMantto';
import { fetchWithWatch } from '../../../../../hooks/fetchWithWatch';
import { ItemBooking, ItemEquipment, ItemFlight, ItemNote } from '../../../../../resources/types';
import { buildBreadcrumbItems, downloadFile, getCookie, getUrlVersion, setLoading } from '../../../../commons/functions';

interface EquipmentGroup {
  idCategory: number;
  category: string;
  equipments: ItemEquipment[];
}
const containerStyle = {
  width: '100%',
  height: '400px',
}

export const MembersEquipmentsStatePage = () => {
  const options = useMemo(() => ({
    //zoom: 1, // Zoom inicial correcto
    zoomControl: true,
    streetViewControl: false,
    mapTypeControl: false,
    fullscreenControl: false,
    mapTypeId: 'satellite' as google.maps.MapTypeId,
  }), []);

  const { idUser, menu } = useGlobalState();
  const [equipments, setEquipments] = useState<ItemEquipment[]>([]);
  const [bookings, setBookings] = useState<ItemBooking[]>([]);
  const [flights, setFlights] = useState<ItemFlight[]>([]);
  const [equipment, setEquipment] = useState<ItemEquipment | null>(null);
  const [notes, setNotes] = useState<ItemNote[]>([]);
  const [note, setNote] = useState<ItemNote>();

  const [idEquipment, setIdEquipment] = useState<number>(0);
  const [activeTabId, setActiveTabId] = useState<string>("equipment");
  const [flarm24, setFlarm24] = useState();
  const [flarm, setFlarm] = useState<any>();
  const [filteringText, setFilteringText] = useState<string>("");
  const [title, setTitle] = useState<string>("Estado de aeronaves");


  const handleGetFlarm = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/flights/ogndevice',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          flarm24: equipment?.flarm24

        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.lkp) {
        setFlarm(data.lkp);
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleGetEquipments = async () => {
    try {
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/equipments/list',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          columns: "idEquipment, registration, make, model, idCategory, category, isOutOfFlight, isMant, isActiveEquipment, isDeleteEquipment, jsonOwners, obsCMA",
          isActiveEquipment: 1,
          isDeleteEquipment: 0,
          isMant: 1,
          orderBy: "registration",
          order: "ASC"

        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.equipments) {
        const filteredEquipments = data.equipments.filter((eq: { jsonOwners: any; }) => {
          const owners = Array.isArray(eq.jsonOwners) ? eq.jsonOwners : [];
          return owners.length === 0 || owners.includes(idUser);
        });
        setEquipments(filteredEquipments);
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };


  const handleGetEquipment = async (idEquipment: number) => {
    try {
      setLoading(true);
      setEquipment(undefined);
      setBookings([]);
      setFlights([]);
      setNotes([]);
      setNotes(undefined);
      setNote(undefined);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/equipments/get',
          'JWT': getCookie("JWT"),

        },
        body: JSON.stringify({
          idEquipment: idEquipment,
          notes: true,
          docs: true,
          image: true,
          bookings: true,
          flights: true,

        })
      });
      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }

      const data = await response.json();
      if (data && data.equipment) {
        setEquipment(data.equipment);
        setTitle("Estado " + (data.equipment.registration));
        if (data.equipment.bookings) {
          setBookings(data.equipment.bookings);
        }
        if (data.equipment.flights) {
          //setFlights(data.equipment.flights);
        }
        if (data.equipment.notes) {
          setNotes(data.equipment.notes);
        }
      }
      //storeAdmin(data);
      // Create a new list with updated 'accesos' field before setting it to state

    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  useEffect(() => {
    if (idEquipment === 0) {
      setTitle("Estado de aeronaves");
    } else {
      setTitle("Estado " + (equipment ? equipment.registration : ""));
    }
  }, [idEquipment]);

  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      const params = new URLSearchParams(hash.split("?")[1]);
      const id = params.get("id");

      setIdEquipment(id ? parseInt(id) : 0);
    };

    window.addEventListener("hashchange", handleHashChange);
    // also trigger once on mount
    handleHashChange();

    return () => window.removeEventListener("hashchange", handleHashChange);
  }, []);
  useEffect(() => {
    if (idEquipment !== 0) {
      handleGetEquipment(idEquipment);
    }
  }, [idEquipment]);

  useEffect(() => {

    setNote(undefined);
    if (idEquipment !== 0) {
      //console.log(activeTabId)
      if (activeTabId === "logs")
        handleGetFlightLogs();
      else if (activeTabId === "bookings")
        handleGetBookings();
      else if (activeTabId === "maintenance")
        handleGetMants();

    }
  }, [activeTabId]);

  const handleGetFlightLogs = async () => {
    try {
      setBookings([]);
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/flights/list',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({
          limit: 30,
          //columns: "idBooking, ",
          idEquipment: idEquipment,
          orderBy: "departureDate",
          order: "DESC",
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      if (data && data.flights) {
        setFlights(data.flights)
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleGetMants = async () => {
    try {
      setBookings([]);
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/mants/list',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({
          limit: 30,
          //columns: "idBooking, ",
          images: true,
          idEquipment: idEquipment,
          orderBy: "dateSubmited",
          order: "DESC",
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      if (data && data.notes) {
        setNotes(data.notes)
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };
  const handleGetMant = async (id: number) => {
    try {
      setBookings([]);
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/mants/get',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({ idMaintenance: id, images: true, logs: true })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      if (data && data.note) {
        setNote(data.note)
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleGetBookings = async () => {
    try {
      setBookings([]);
      setLoading(true);
      const response = await fetchWithWatch(`${getUrlVersion()}/routing/v1/`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          'x-routing': '/private/global/bookings/list',
          'JWT': getCookie("JWT"),

        },

        body: JSON.stringify({
          limit: 30,
          columns: "idBooking, idBookingType, idCategory, idEquipment, idGroupType, idInstructor, idUser, idInstructor, displayName, instructor, make, model, obsBooking, dateStart, dateEnd, dateSubmited, registration, towType, thresholdAfter, thresholdBefore, bookingType, equipment, bookingTypeBadge, bookingType, groupType, groupTypeMaster, groupTypeMasterCode, minBookHour, maxBookHour, obsCMA",
          idEquipment: idEquipment,
          orderBy: "dateEnd",
          order: "DESC",
          orderBy2: "ordenGroupType",
          order2: "ASC"
        })
      });

      if (!response.ok) {
        throw new Error(`HTTP error: ${response.status}`);
      }
      const data = await response.json();
      if (data && data.bookings) {
        setBookings(data.bookings)
      }
    } catch (error) {
      console.error('Error fetching users:', error);
    } finally {
      setLoading(false);
    }
  };

  const filteredEquipments = equipments.filter((e: ItemEquipment) => {
    const matchesMant = e.isMant === 1;
    const matchesSearch = filteringText
      ? e.registration.toLowerCase().includes(filteringText.toLowerCase()) ||
      e.model.toLowerCase().includes(filteringText.toLowerCase()) ||
      e.category.toLowerCase().includes(filteringText.toLowerCase()) ||
      e.make?.toLowerCase().includes(filteringText.toLowerCase())
      : true;

    return matchesMant && matchesSearch;
  });

  const mainGroupIds = new Set<number>(
    filteredEquipments
      .filter((e: ItemEquipment) => e.isMant === 1)
      .map((e: ItemEquipment) => e.idCategory)
  );

  const grouped: EquipmentGroup[] = Array.from(mainGroupIds).map((idCategory: number) => {
    const groupCategory = filteredEquipments.filter(
      (e: ItemEquipment) => e.idCategory === idCategory && e.isMant === 1
    );

    const { category } = groupCategory[0];

    return {
      idCategory,
      category,
      equipments: groupCategory
    };
  });

  const onLoad = useCallback(function callback(map: any) {
    setMap(map);
  }, []);

  const onUnmount = useCallback(function callback(map: any) {
    setMap(null);
  }, []);
  const API_KEY = 'AIzaSyArNTcY1e_oLKgply89Mx2NySzONuIsYYc';

  // Hook para manejar la carga de la API
  const { isLoaded } = useJsApiLoader({
    id: 'google-map-script',
    googleMapsApiKey: API_KEY,
  });
  const [map, setMap] = useState<google.maps.Map | null>(null);
  useEffect(() => {
    handleGetEquipments()

  }, []);
  return (
    <CustomAppLayout

      toolsHide={true}
      splitPanelOpen={!!note}
      onSplitPanelToggle={({ detail }) => !detail.open ? setNote(undefined) : null}
      splitPanel={
        <SidePanelMant note={note ?? {}} />
      }
      breadcrumbs={
        <BreadcrumbGroup
          items={buildBreadcrumbItems(menu)}
          expandAriaLabel="Show path"
          ariaLabel="Breadcrumbs"
        />
      }
      content={
        <SpaceBetween size="s">
          <Header variant="h1"
            actions={
              <SpaceBetween size="xs" direction='horizontal'>
                {!!idEquipment && (
                  <Button variant='link' onClick={() => {
                    setIdEquipment(0)
                    setEquipment(undefined)
                    setNote(undefined)
                    window.location.hash = '#members/equipments/state';
                  }}>Volver</Button>)}
                <Favorites />
              </SpaceBetween>}
          >{title}</Header>
          {!idEquipment && (
            <SpaceBetween size="l">
              <TextFilter filteringText={filteringText} onChange={(e) => {
                setFilteringText(e.detail.filteringText)
              }} />
              {grouped.map(group => (
                <Box key={group.idCategory}>
                  <Header variant="h2">{group.category}</Header>
                  <Cards
                    items={group.equipments}
                    cardDefinition={{
                      header: (item: any) => (
                        <Header variant="h3"
                          actions={
                            <Badge color={item.isOutOfFlight === 1 ? "red" : "green"}>
                              {item.isOutOfFlight === 1 ? "Fuera de vuelo" : "En vuelo"}
                            </Badge>
                          }>
                          {item?.registration || "Sin matrícula"}
                        </Header>
                      ),
                      sections: [
                        {
                          id: "details",
                          content: (item) => (
                            <SpaceBetween size="xs">
                              <KeyValuePairs
                                columns={2}
                                items={[
                                  { label: "Fabricante/Modelo", value: `${item.make}-${item.model}` || "—" },
                                  ...(item.obsCMA && item.obsCMA !== "" ? [{ label: "Obs CMA", value: item.obsCMA }] : []),
                                ]}
                              />
                              <Button variant="link" onClick={() => {
                                location.hash = '#members/equipments/state?id=' + item.idEquipment.toString();
                              }}>Detalle</Button>
                            </SpaceBetween>
                          )
                        }
                      ]
                    }}
                    cardsPerRow={[{ cards: 1 }, { minWidth: 500, cards: 2 }, { minWidth: 800, cards: 3 }]}
                    empty={<div>No hay equipos en esta categoría</div>}
                  />

                </Box>
              ))}
            </SpaceBetween>
          )}

          {!!equipment && (
            <Tabs activeTabId={activeTabId} tabs={[
              {
                id: "equipment", label: "Material", content: (
                  <SpaceBetween size="s" direction='vertical'>
                    <SpaceBetween size="s" direction='horizontal'>
                      <FormField label="Matrícula">
                        {equipment.registration}
                      </FormField>
                      <FormField label="Marca">
                        {equipment.make}
                      </FormField>
                      <FormField label="Modelo">
                        {equipment.model}
                      </FormField>
                    </SpaceBetween>


                    <SpaceBetween size="s" direction='horizontal'>
                      {equipment.idSpider && equipment.idSpider !== "" && (
                        <FormField label={<><Icon path={mdiSpiderOutline} size={1} />Spider</>}>
                          {equipment.idSpider}
                        </FormField>
                      )}
                      {equipment.idFlarm && equipment.idFlarm !== "" && (
                        <FormField label={<><Icon path={mdiRadar} size={1} />Flarm</>}>
                          {equipment.idFlarm}
                        </FormField>
                      )}
                      {equipment.flarm24 && equipment.flarm24 !== "" && (
                        <FormField label={<><Icon path={mdiMapMarkerRightOutline} size={1} />LKP</>}>
                          <Link onClick={() => {
                            handleGetFlarm()

                          }}>Ver mapa</Link>
                        </FormField>
                      )}
                    </SpaceBetween>
                    {equipment.obsCMA && equipment.obsCMA !== "" && (
                      <Alert type="info" header="Observaciones CMA">
                        {equipment.obsCMA}
                      </Alert>
                    )}

                    {equipment.image && equipment.image !== "" && (
                      <img src={equipment.image}
                        style={{ borderRadius: "25px", width: "100%" }} alt={equipment.registration}

                      />
                    )}
                  </SpaceBetween>
                )
              },
              {
                id: "docs", label: "Documentación", content: (

                  <Table

                    variant='embedded'
                    columnDefinitions={[
                      {
                        id: "type",
                        header: "",
                        cell: item => item.type
                      },
                      {
                        id: "doc",
                        header: "Documento",
                        cell: item =>
                          item.url !== "" ? (
                            <Link
                              onClick={async () => {
                                setLoading(true);
                                await downloadFile(item.url, item.doc);
                                setLoading(false);
                              }}
                            >
                              {item.doc}
                            </Link>
                          ) : (
                            item.doc
                          )
                      },
                      {
                        id: "date",
                        header: "Fecha",
                        cell: item => item.url === "" ? "N/D" : item.date
                      },
                    ]}

                    items={equipment.docs}
                  />
                )
              },
              {
                id: "maintenance", label: "Mantenimiento", content: (
                  <TableManttos notes={notes} hidePaging onSelect={(item: ItemNote) => handleGetMant(item.idMaintenance)} showEquipment={false} />

                )
              },
              {
                id: "logs", label: "Bitácoras", content: (
                  <TableFlights flights={flights} showEquipment={false} />

                )
              },
              {
                id: "bookings", label: "Reservas", content: (
                  <TableBookings headers={false} range={false} visible bookings={bookings || []} onBookingClick={() => {
                  }} />
                )
              },
            ]} onChange={(e) => setActiveTabId(e.detail.activeTabId)} />
          )}
          {isLoaded && !!flarm && (
            <Modal size="max" visible={!!flarm} onDismiss={() => setFlarm(undefined)} closeAriaLabel="Close modal" header="Última posición conocida">
              <SpaceBetween size="s" direction='vertical'>
                <SpaceBetween size="s" direction='horizontal'>
                  <Icon path={mdiCheckCircle} size={1} color={!!flarm.alive ? "green" : "red"} />{!!flarm.alive ? " Online" : " Offline"}
                </SpaceBetween>
                <GoogleMap

                  onLoad={onLoad}
                  onUnmount={onUnmount}
                  mapContainerStyle={containerStyle}
                  center={{ lat: flarm?.lat, lng: flarm?.lng }}
                  zoom={12}
                  options={options}
                >
                  <Marker position={{ lat: flarm?.lat, lng: flarm?.lng }} />
                </GoogleMap>
                <SpaceBetween size="s" direction='horizontal'>
                  <FormField label="ALT" constraintText="QNH">
                    {flarm.alt} m
                  </FormField>
                  <FormField label="GSP" constraintText="Ground Speed">
                    {flarm.gsp} km/h
                  </FormField>
                  <FormField label="TRK" constraintText="Direction">
                    {flarm.track}º
                  </FormField>
                  <FormField label="TS" info={"Local"} constraintText={format(fromUnixTime(flarm.tsp), 'HH:mm:ss')}>
                    {format(fromUnixTime(flarm.tsp), 'dd-MM-yyyy')}
                  </FormField>
                </SpaceBetween>
                <SpaceBetween size="s" direction='horizontal'>
                  <FormField label="Latitude" constraintText={`DMS ${flarm.lat_dms}`}>
                    {Math.round(flarm.lat * 10000) / 10000}
                  </FormField>
                  <FormField label="Longitude" constraintText={`DMS ${flarm.lng_dms}`}>
                    {Math.round(flarm.lng * 10000) / 10000}
                  </FormField>

                </SpaceBetween>
              </SpaceBetween>
            </Modal>
          )}
        </SpaceBetween>
      }
    />
  );
};
